module.exports = __webpack_public_path__ + "static/media/tinywow_Artemisiavulgaris_colored_55476013.294f4e86.jpg";